import { render, staticRenderFns } from "./LibraryNotes.vue?vue&type=template&id=54a9859f&scoped=true"
import script from "./LibraryNotes.vue?vue&type=script&lang=js"
export * from "./LibraryNotes.vue?vue&type=script&lang=js"
import style0 from "./LibraryNotes.vue?vue&type=style&index=0&id=54a9859f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9859f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VSelect,VTextField})
